export default class BlockPriceTag {
	constructor() {

		let blocks = document.querySelectorAll('.block-price-tag');

		blocks.forEach((block) => {

		});
	}
}
